import { render, staticRenderFns } from "./MobilePreventionSafetyRequest.vue?vue&type=template&id=94b15026&scoped=true&"
import script from "./MobilePreventionSafetyRequest.vue?vue&type=script&lang=js&"
export * from "./MobilePreventionSafetyRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b15026",
  null
  
)

export default component.exports